import ExcelSvg from './excel-svg';
import OtherSvg from './other-svg';
import PdfSvg from './pdf-svg';
import VideoSvg from './video-svg';
import WordSvg from './word-svg';
import ZipSvg from './zip-svg';
export default {
    ExcelSvg,
    OtherSvg,
    PdfSvg,
    VideoSvg,
    WordSvg,
    ZipSvg,
};
